/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "backendapi",
            "endpoint": "https://b89ns5qxe2.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "backendapis",
            "endpoint": "https://f7t2zsdn5g.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "quicksight",
            "endpoint": "https://rxvj76ggcl.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:3bed750a-a8a0-4866-b823-8f474cea8e6f",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_O4uSMgJop",
    "aws_user_pools_web_client_id": "2fjhb2hinh6k3j8bet1ghlr6ph",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "insurance-dashboard-imagesdd445-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
